// @core/api/endpoints/secret/initialize.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  InitializeRequest,
  InitializeResponse,
} from '../../../types/secret';

const BASE_PATH = '/secret';

/**
 * Initialize secret service
 * Initializes the Secret service by generating a master key split into Shamir shares. Must be called once before the service can be used. Returns the unseal keys and initial root token.
 * @public This endpoint does not require authentication
 */
export async function Initialize(
  data: InitializeRequest,
  options?: RequestOptions
): Promise<InitializeResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/sys/init`;
  const requestOptions = { ...options, skipAuth: true };
  return client.post<InitializeResponse>(requestPath, data, requestOptions);
}
